import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader, LoopOnce } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const Confetti = () => {
  const ref = useRef();
  const model = useGLTF(defineSrc('confetti.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('confetti-light.json'));
  const {
    mixer,
    clips
  } = useAnimations(model.animations, ref);
  useFrame(() => {
    model.materials['Tapestry WebGL'].map.offset.x += -15e-4;
    mixer.clipAction(clips[0]).play().setLoop(LoopOnce, 1);
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: ref,
      scale: 1.5,
      position: [0, 1.5, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Confetti as default };
//# sourceMappingURL=Confetti-CWZxburd.esm.js.map
